import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {VoyagePlanningLazy} from "@containers/voyagePlanning/VoyagePlanning.lazy";
import {sx} from './sx'
import UserAccessRoot from "@containers/account/access/userAccess/UserAccessRoot";
import {ACCESS_KEYS_VOYAGE_VIEW} from "@containers/account/access/constants/accessList/voyage";

const VoyagePlanningPage = () => {
    return (
        <PageLayout
            sx={sx.root}
        >
            {/*
              * Viewing the plan only needs acl.voyage.READ — that is all VoyagePlanningController asks
              * of its GET endpoints. Planning itself is gated inside (useVoyagePlanningAccess).
              */}
            <UserAccessRoot
                accessType={'or'}
                keys={ACCESS_KEYS_VOYAGE_VIEW}
            >
                <Suspense
                    fallback={<SpinnerCustom/>}
                >
                    <VoyagePlanningLazy/>
                </Suspense>
            </UserAccessRoot>
        </PageLayout>
    )
};

export default VoyagePlanningPage;